import AdminSidebar from "../../../components/sidebars/admin/AdminSidebar";
import Dashboard from "../../admin/Dashboard";
import Medicos from "../../medicos/Medicos";
import ObrasSociales from "../../obrasSociales/ObrasSociales";
import Pacientes from "../../pacientes/Pacientes";
import Planes from "../../planes/Planes";
import Sedes from "../../sedes/Sedes";
import Servicios from "../../servicios/Servicios";
import Turnos from "../../turnos/Turnos";
import Usuarios from "../../usuarios/Usuarios";
import "./AdminLayout.css";
import {useNavigate, useParams} from "react-router";

const AdminLayout = ({ user, onLogout }) => {
    const { page: currentPage } = useParams();
    const navigate = useNavigate();
    const onNavigate = (page) => navigate(`/admin/${page}`);

    const renderPage = () => {
        if (currentPage === "servicios") {
            return <Servicios />;
        }

        if (currentPage === "medicos") {
            return <Medicos />;
        }

        if (currentPage === "pacientes") {
            return <Pacientes />;
        }

        if (currentPage === "turnos") {
            return <Turnos />;
        }

        if (currentPage === "sedes") {
            return <Sedes />;
        }

        if (currentPage === "usuarios") {
            return <Usuarios />;
        }

        if (currentPage === "obrasSociales") {
            return <ObrasSociales />;
        }

        if (currentPage === "planes") {
            return <Planes />;
        }

        if (currentPage === "dashboard") {
            return <Dashboard />;
        }

        return (
            <section className="admin-layout__placeholder">
                <strong>Sección en construcción</strong>
                <p>Esta pantalla se implementará en la próxima etapa.</p>
            </section>
        );
    };

    return (
        <div className="admin-layout">
            <AdminSidebar
                currentPage={currentPage}
                onNavigate={onNavigate}
                user={user}
                onLogout={onLogout}
            />

            <main id="admin-main-content" className="admin-layout__main" tabIndex={-1} aria-label="Contenido principal">
                {renderPage()}
            </main>
        </div>
    );
};

export default AdminLayout;